import { render, staticRenderFns } from "./allocate-invoices.vue?vue&type=template&id=24bcfec6"
import script from "./allocate-invoices.vue?vue&type=script&lang=js"
export * from "./allocate-invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports